import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const Breadcrumbs = ({ items }) => {
  const { t } = useLang();
  const crumbs = [{ label: t("nav.home"), to: "/" }, ...items];
  return (
    <nav aria-label="Breadcrumb" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-hacienda-gray">
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={c.to} className="flex items-center gap-1">
              {last ? (
                <span className="text-hacienda-charcoal font-medium" aria-current="page">{c.label}</span>
              ) : (
                <Link to={c.to} className="hover:text-hacienda-terracotta transition-colors">{c.label}</Link>
              )}
              {!last && <ChevronRight size={14} aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
